import { ThemeApp } from 'themes/types/themeApp/theme.types';
import { themeUi } from '../../themeUi/themeUi';

const subscriptionsAndDatabases: ThemeApp['appComponents']['subscriptionsAndDatabases'] = {
  subscriptions: {
    changeSubPlan: {
      changeSubPlan: {
        title: {
          color: themeUi.semantic.color.text.neutral800
        }
      },

      components: {
        subscriptionDetails: {
          subscriptionDetails: {
            backgroundColor: themeUi.semantic.color.background.neutral100
          },
          subID: {
            color: themeUi.semantic.color.text.neutral800
          },
          horizontalLine: {
            borderBottom: themeUi.semantic.color.border.secondary300
          },
          cloudVendorText: {
            color: themeUi.semantic.color.text.neutral800
          }
        }
      }
    },

    subscriptionDetails: {
      components: {
        connectivity: {
          psc: {
            components: {
              createConnectionForm: {
                createConnectionForm: {
                  creationForm: {
                    backgroundColor: themeUi.semantic.color.background.neutral100
                  },
                  creationFormTitle: {
                    color: themeUi.semantic.color.text.neutral800
                  },
                  stepCircle: {
                    activeBackgroundColor: themeUi.semantic.color.background.primary500,
                    normalBackgroundColor: themeUi.semantic.color.background.secondary300
                  },
                  stepCircleDivider: {
                    backgroundColor: themeUi.semantic.color.background.secondary300
                  },
                  divider: {
                    backgroundColor: themeUi.semantic.color.background.secondary300
                  }
                },

                components: {
                  addConnectionsStep: {
                    addConnectionTitle: {
                      color: themeUi.semantic.color.text.neutral800
                    },
                    addConnectionDescription: {
                      color: themeUi.semantic.color.text.neutral800
                    }
                  },

                  endpointDetailsStep: {
                    formBodyTitle: {
                      color: themeUi.semantic.color.text.neutral800
                    }
                  },

                  endpointScripTextArea: {
                    endpointScriptTextArea: {
                      scriptLabel: {
                        borderBottom: themeUi.semantic.color.border.primary600,
                        color: themeUi.semantic.color.text.primary600
                      }
                    }
                  }
                }
              },

              pscEmptyListFallback: {
                pscEmptyListFallback: {
                  description: {
                    color: themeUi.semantic.color.text.notice700
                  }
                },

                components: {
                  disableStateInfo: {
                    disableStateInfo: {
                      backgroundColor: themeUi.semantic.color.background.primary100,
                      color: themeUi.semantic.color.text.notice700
                    }
                  }
                }
              },

              pscFailedScreen: {
                pscFailedTitle: {
                  color: themeUi.semantic.color.text.danger500,
                  fontSize: themeUi.core.font.fontSize.s18
                },
                pscFailedDescription: {
                  fontSize: themeUi.core.font.fontSize.s14
                },
                pscErrorContainer: {
                  backgroundColor: themeUi.semantic.color.text.neutral100
                }
              },

              pscTable: {
                pscTable: {
                  tableTitle: {
                    color: themeUi.semantic.color.text.neutral800
                  },
                  pscProjectName: {
                    color: themeUi.semantic.color.text.neutral600
                  }
                },

                pscTableCells: {
                  hostCell: {
                    components: {
                      connectDbDrawer: {
                        connectDescription: {
                          color: themeUi.semantic.color.text.neutral800,
                          fontSize: themeUi.core.font.fontSize.s16
                        },
                        pscEndpointHostAndPort: {
                          backgroundColor: themeUi.semantic.color.background.neutral300
                        },
                        dbPort: {
                          color: themeUi.semantic.color.text.primary500,
                          fontSize: themeUi.core.font.fontSize.s14
                        }
                      }
                    }
                  }
                }
              }
            }
          },

          tgw: {
            components: {
              tgwCard: {
                tgwCard: {
                  cardBodyValue: {
                    backgroundColor: themeUi.semantic.color.background.neutral300,
                    color: themeUi.semantic.color.text.neutral700,
                    fontFamily: themeUi.core.font.fontFamily.sourceCodeProRegular
                  },
                  cardBodyTitle: {
                    fontSize: themeUi.core.font.fontSize.s16,
                    color: themeUi.semantic.color.text.neutral800
                  },
                  cardBodyDescription: {
                    fontSize: themeUi.core.font.fontSize.s14,
                    color: themeUi.semantic.color.text.neutral700
                  },
                  divider: {
                    borderLeft: themeUi.semantic.color.border.secondary300
                  }
                },

                components: {
                  resourceSharesButton: {
                    missingPermissionsModal: {
                      accountName: {
                        color: themeUi.semantic.color.text.primary600
                      }
                    },

                    sharedInvitationsNumber: {
                      backgroundColor: themeUi.semantic.color.background.success500,
                      color: themeUi.semantic.color.text.neutral100,
                      fontSize: themeUi.core.font.fontSize.s10
                    }
                  },

                  tgwResourceDrawer: {
                    tgwResourceTable: {
                      tgwResourceTable: {
                        border: themeUi.semantic.color.border.neutral500
                      },

                      components: {
                        acceptRejectCell: {
                          acceptingStatusText: {
                            color: themeUi.semantic.color.text.neutral700
                          },
                          acceptedStatusText: {
                            color: themeUi.semantic.color.text.success500
                          },
                          rejectedStatusText: {
                            color: themeUi.semantic.color.text.danger500
                          }
                        }
                      }
                    }
                  }
                }
              },

              tgwTable: {
                components: {
                  consumerCIDRsCell: {
                    components: {
                      tgwAttachmentDrawer: {
                        tgwAttachmentDrawer: {
                          attachmentTable: {
                            border: themeUi.semantic.color.border.neutral500
                          },
                          additionalDataTitle: {
                            color: themeUi.semantic.color.text.neutral800
                          },
                          additionalDataValue: {
                            color: themeUi.semantic.color.text.neutral700
                          },
                          divider: {
                            darkBorderBottom: themeUi.semantic.color.border.neutral500,
                            normalBorderBottom: themeUi.semantic.color.border.secondary300
                          },
                          routingRuleBanner: {
                            backgroundColor: themeUi.semantic.color.background.primary50
                          }
                        },

                        components: {
                          blackHoleCidrIndicator: {
                            blackholeWarningMessage: {
                              color: themeUi.semantic.color.text.neutral700,
                              fontSize: themeUi.core.font.fontSize.s12
                            },
                            indicatorIcon: {
                              color: themeUi.semantic.color.text.attention500
                            }
                          },

                          createTgwCidrs: {
                            consumerCidrsList: {
                              color: themeUi.semantic.color.text.neutral800
                            }
                          },
                          editTgwCidrs: {
                            consumerCidrsList: {
                              color: themeUi.semantic.color.text.neutral800
                            }
                          },
                          tgwCidrs: {
                            consumerCidrsTitle: {
                              color: themeUi.semantic.color.text.neutral800
                            }
                          },
                          viewTgwCidrs: {
                            consumerCidrsList: {
                              color: themeUi.semantic.color.text.neutral800
                            },
                            emptyCidrsListText: {
                              color: themeUi.semantic.color.text.neutral700
                            }
                          }
                        }
                      },

                      tgwCidrComponent: {
                        blackholeIndicator: {
                          blackHoleExistIndicator: {
                            tooltipTextParagraph: {
                              color: themeUi.semantic.color.text.neutral800
                            }
                          }
                        },

                        tgwCidrComponent: {
                          color: themeUi.semantic.color.text.neutral800
                        }
                      }
                    }
                  }
                }
              }
            }
          },

          vpcPeering: {
            components: {
              addVpcDialogs: {
                addVpcPeeringDrawerContent: {
                  addVpcPeeringDrawerContent: {
                    drawerForm: {
                      borderBottom: themeUi.semantic.color.border.secondary300
                    }
                  },

                  addVpcPeeringDrawerHeader: {
                    DrawerExplanation: {
                      color: themeUi.semantic.color.text.neutral700
                    }
                  },

                  components: {
                    awsPeeringContent: {
                      components: {
                        addAwsPeeringCidrs: {
                          vpcCidrsTitle: {
                            color: themeUi.semantic.color.text.neutral800
                          }
                        },

                        regionsDropdown: {
                          regionDisplayField: {
                            color: themeUi.semantic.color.text.neutral700
                          }
                        }
                      }
                    },

                    gcpPeeringContent: {
                      components: {
                        googleCloudCommand: {
                          components: {
                            commandDisplayAndCopy: {
                              title: {
                                color: themeUi.semantic.color.text.neutral700
                              },
                              commandContainer: {
                                border: themeUi.semantic.color.border.neutral500
                              },
                              commandText: {
                                color: themeUi.semantic.color.text.neutral800
                              }
                            }
                          }
                        }
                      }
                    },

                    redisCidrBox: {
                      redisCidrBox: {
                        backgroundColor: themeUi.semantic.color.background.primary50
                      }
                    }
                  }
                }
              }
            }
          },

          privateLink: {
            components: {
              shareResourceCard: {
                shareResourceCard: {
                  backgroundColor: themeUi.semantic.color.background.transparent,
                  shareInfoSection: {
                    cardBannerLink: {
                      color: themeUi.semantic.color.text.notice700
                    },
                    copyBox: {
                      backgroundColor: themeUi.semantic.color.background.primary50,
                      borderRadius: themeUi.components.boxSelectionGroup.item.borderRadius
                    }
                  }
                }
              },
              addConnectionCard: {
                addConnectionCard: {
                  divider: {
                    borderLeft: themeUi.semantic.color.border.secondary300
                  },
                  redisCidrBox: {
                    redisCidrBox: {
                      backgroundColor: themeUi.semantic.color.background.primary50,
                      borderRadius: themeUi.components.boxSelectionGroup.item.borderRadius
                    }
                  }
                }
              },

              connectionsCard: {
                connectionsCard: {
                  connectionsDrawer: {
                    connectionsDrawerBody: {
                      endpointHostAndPort: {
                        backgroundColor: themeUi.semantic.color.background.neutral300,
                        border: themeUi.semantic.color.border.secondary300
                      }
                    }
                  }
                }
              }
            }
          }
        },

        customerManaged: {
          encryptionKeyCreateForm: {
            encryptionKeyCreateForm: {
              divider: {
                borderTop: themeUi.semantic.color.border.neutral600
              }
            },

            components: {
              grantAccessGCPCard: {
                dividerText: {
                  color: themeUi.semantic.color.border.neutral800
                },
                input: {
                  color: themeUi.semantic.color.border.neutral700
                },
                dividerVertical: {
                  borderRightColor: themeUi.semantic.color.border.secondary300
                },
                divider: {
                  borderTopColor: themeUi.semantic.color.border.secondary300
                }
              },

              stepCard: {
                card: {
                  border: themeUi.semantic.color.border.neutral500
                },
                stepCircle: {
                  color: themeUi.semantic.color.text.neutral700,
                  backgroundColor: themeUi.semantic.color.background.primary100
                }
              },
              providerResourcesCard: {
                title: {
                  color: themeUi.semantic.color.text.neutral800
                },
                countryCity: {
                  color: themeUi.semantic.color.text.neutral800
                }
              }
            }
          }
        },

        overview: {
          overview: {
            card: {
              backgroundColor: themeUi.semantic.color.background.secondary0,
              boxShadow: themeUi.core.shadow.shadow4
            },
            text: {
              color: themeUi.semantic.color.text.neutral800
            },
            header: {
              color: themeUi.semantic.color.text.neutral800
            },
            divider: {
              normalBorderTop: themeUi.semantic.color.border.secondary300,
              boldBorderTop: themeUi.semantic.color.border.secondary300
            },
            dividerVertical: {
              borderRight: themeUi.semantic.color.border.secondary300
            },
            spacer: {
              color: themeUi.semantic.color.text.neutral500
            }
          },

          components: {
            databasePlanCard: {
              divider: {
                backgroundColor: themeUi.semantic.color.background.secondary300
              }
            },

            maintenanceWindow: {
              explanationText: {
                color: themeUi.semantic.color.text.neutral800
              },
              title: {
                color: themeUi.semantic.color.text.neutral800
              },
              errorBanner: {
                backgroundColor: themeUi.semantic.color.background.attention100,
                borderColor: themeUi.semantic.color.border.attention200,
                color: themeUi.semantic.color.text.attention700,

                buttonBackgroundColor: themeUi.semantic.color.background.attention100,
                buttonBorderColor: themeUi.semantic.color.border.attention200,
                buttonColor: themeUi.semantic.color.text.attention700,

                buttonHoverBackgroundColor: themeUi.semantic.color.background.attention200,
                buttonHoverColor: themeUi.semantic.color.text.neutral700
              },
              divider: {
                borderBottomColor: themeUi.semantic.color.border.secondary300
              },

              manualSection: {
                recommendationStyle: {
                  satisfiedColor: themeUi.semantic.color.text.success600,
                  unsatisfiedColor: themeUi.semantic.color.text.neutral600
                },
                explanationTitle: {
                  color: themeUi.semantic.color.text.neutral800
                },
                addButton: {
                  color: themeUi.semantic.color.text.primary600,
                  backgroundColor: themeUi.semantic.color.background.primary50,
                  hoverColor: themeUi.semantic.color.text.primary600,
                  hoverBackgroundColor: themeUi.semantic.color.background.primary100
                }
              },

              readOnlyView: {
                tile: {
                  backgroundColor: themeUi.semantic.color.background.neutral100,
                  color: themeUi.semantic.color.text.secondary600
                },
                label: {
                  color: themeUi.semantic.color.text.secondary950
                }
              },

              skipMaintenance: {
                remainingSkips: {
                  color: themeUi.semantic.color.text.neutral700
                },
                skipButton: {
                  backgroundColor: themeUi.semantic.color.background.neutral100
                }
              },

              timeFrame: {
                windowDescriptionContainer: {
                  color: themeUi.semantic.color.text.neutral800
                }
              }
            },

            pricingCard: {
              hourlyPriceValue: {
                borderTop: themeUi.semantic.color.border.secondary300
              }
            }
          }
        },

        payNowOrCancel: {
          PayNowContainer: {
            borderTop: themeUi.semantic.color.border.neutral600
          }
        },

        planCard: {
          metaContainer: {
            borderTop: themeUi.semantic.color.border.secondary300,
            borderBottom: themeUi.semantic.color.border.secondary300
          },

          metaItemText: {
            color: themeUi.semantic.color.text.neutral700
          },

          divider: {
            backgroundColor: themeUi.semantic.color.background.secondary300
          },

          components: {
            editSubscriptionName: {
              subscriptionName: {
                color: themeUi.semantic.color.text.secondary950
              }
            }
          }
        },

        regions: {
          components: {
            addRegion: {
              components: {
                addRegionDialog: {
                  components: {
                    steps: {
                      throughput: {
                        table: {
                          border: themeUi.semantic.color.border.secondary300
                        }
                      }
                    }
                  }
                }
              }
            },

            regionAccessTooltip: {
              tooltipHeader: {
                backgroundColor: themeUi.semantic.color.background.attention100
              },
              title: {
                color: themeUi.semantic.color.text.neutral800
              },
              strongText: {
                color: themeUi.semantic.color.text.neutral800
              },
              bodyText: {
                color: themeUi.semantic.color.text.neutral800
              }
            },

            submitDialog: {
              components: {
                affectedRegions: {
                  listContainer: {
                    borderColor: themeUi.semantic.color.border.secondary300
                  },
                  listItem: {
                    borderTopColor: themeUi.semantic.color.border.secondary300
                  },
                  actionLabel: {
                    color: themeUi.semantic.color.text.danger500
                  }
                }
              }
            }
          }
        },

        subscriptionDetailsHeader: {
          subscriptionMetadataContainer: {
            color: themeUi.semantic.color.text.neutral800
          },
          subscriptionName: {
            color: themeUi.semantic.color.text.secondary950
          },

          components: {
            subscriptionMetadata: {
              subscriptionMetadata: {
                color: themeUi.semantic.color.text.neutral700
              }
            },

            advancedTooltipErrorContent: {
              subDetailsTooltipErrorText: {
                color: themeUi.semantic.color.text.danger500
              }
            },

            changePlanTooltip: {
              closeIcon: {
                color: themeUi.semantic.color.text.neutral700
              },
              tooltipTitle: {
                color: themeUi.semantic.color.text.neutral800
              },
              text: {
                color: themeUi.semantic.color.text.neutral800
              }
            },

            createDbButton: {
              components: {
                tooltipContent: {
                  tooltipTextExplanation: {
                    backgroundColor: themeUi.semantic.color.background.primary50
                  },
                  tooltipTextAction: {
                    borderTop: themeUi.semantic.color.border.secondary300
                  }
                }
              }
            },

            optInRequestButton: {
              optedInBadge: {
                backgroundColor: themeUi.semantic.color.background.success100,
                color: themeUi.semantic.color.text.success600,
                border: themeUi.semantic.color.border.success200,
                fill: themeUi.semantic.color.icon.success600
              },

              optInButton: {
                backgroundColor: themeUi.semantic.color.icon.neutral100
              }
            },

            redisVersionUpgradeRequestButton: {
              upgradeRequestedBadge: {
                backgroundColor: themeUi.semantic.color.background.neutral100
              },
              versionSelectOption: {
                color: themeUi.semantic.color.text.neutral600
              },
              modalExplanation: {
                color: themeUi.semantic.color.text.neutral700
              },
              modalReleaseNotes: {
                color: themeUi.semantic.color.text.neutral800
              }
            }
          }
        }
      }
    },

    components: {
      databaseViewHeader: {
        components: {
          dbsSelectDropDown: {
            subTitle: {
              fontFamily: themeUi.core.font.fontFamily.regular
            }
          }
        }
      },

      bdbMetrics: {
        metricsInfo: {
          color: themeUi.semantic.color.text.neutral700
        }
      }
    }
  },

  components: {
    dbIndicators: {
      components: {
        dbProcesses: {
          labeledProcess: {
            backgroundColor: themeUi.semantic.color.background.neutral100
          }
        }
      }
    },

    dbFormComponents: {
      allowList: {
        components: {
          allowListItems: {
            borderColor: themeUi.semantic.color.border.secondary300
          },
          allowListItem: {
            allowListItemContainer: {
              borderTopColor: themeUi.semantic.color.border.neutral300
            }
          }
        }
      },

      collapseAllButton: {
        collapseAllText: {
          color: themeUi.semantic.color.text.primary600
        }
      },

      configurationSectionItem: {
        description: {
          color: themeUi.semantic.color.text.neutral600
        }
      },

      dangerZoneItem: {
        label: {
          color: themeUi.semantic.color.text.neutral800
        }
      },

      defaultUser: {
        components: {
          defaultUsernameIndication: {
            textContainer: {
              color: themeUi.semantic.color.text.neutral700
            },
            defaultText: {
              color: themeUi.semantic.color.text.notice500
            }
          }
        }
      },

      hashingPolicy: {
        hashingPolicyLabelAndValue: {
          components: {
            hashingPolicyLabel: {
              label: {
                color: themeUi.semantic.color.text.neutral800
              }
            },
            hashingPolicyValue: {
              policyValue: {
                color: themeUi.semantic.color.text.neutral800
              }
            }
          }
        },

        hashingPolicy: {
          policyValue: {
            color: themeUi.semantic.color.text.neutral800
          }
        },

        regexRulesEdit: {
          componentContainer: {
            color: themeUi.semantic.color.text.success500
          },

          components: {
            regexExample: {
              header: {
                color: themeUi.semantic.color.text.neutral800
              },
              column: {
                color: themeUi.semantic.color.text.primary500
              },
              descriptionText: {
                color: themeUi.semantic.color.text.neutral600
              },
              dividerVertical: {
                borderLeft: themeUi.semantic.color.border.secondary300
              }
            },
            regexQuickReference: {
              header: {
                color: themeUi.semantic.color.text.neutral800
              },
              key: {
                color: themeUi.semantic.color.text.primary500
              },
              value: {
                color: themeUi.semantic.color.text.neutral600
              }
            },
            tooltipsContainer: {
              tooltipsContainer: {
                color: themeUi.semantic.color.text.primary600
              }
            }
          }
        }
      },

      alerts: {
        alertText: {
          color: themeUi.semantic.color.text.neutral800
        },
        alertInputText: {
          disabledColor: themeUi.semantic.color.text.neutral500,
          editableColor: themeUi.semantic.color.text.neutral700,
          notActiveColor: themeUi.semantic.color.text.neutral500,
          color: themeUi.semantic.color.text.neutral800
        }
      },

      importDbDialog: {
        components: {
          importIndicator: {
            importText: {
              color: themeUi.semantic.color.text.neutral600
            },
            errorText: {
              color: themeUi.semantic.color.text.danger500
            }
          }
        }
      },

      proxyPolicyOverride: {
        description: {
          color: themeUi.semantic.color.text.neutral600
        }
      },

      quickActionsSection: {
        backgroundColor: themeUi.semantic.color.background.secondary0
      },

      quickActionCardBox: {
        cardBox: {
          borderRadius: themeUi.components.boxSelectionGroup.item.borderRadius,
          borderWidth: themeUi.components.boxSelectionGroup.item.borderWidth,
          borderStyle: themeUi.components.boxSelectionGroup.item.borderStyle,
          borderColor: themeUi.semantic.color.border.secondary300
        }
      },

      remoteBackup: {
        lastUpdateTime: {
          color: themeUi.semantic.color.text.primary400
        },

        components: {
          destinationSection: {
            components: {
              providerBackupDestination: {
                pathPatternText: {
                  color: themeUi.semantic.color.text.neutral600
                }
              }
            }
          },

          explanationSection: {
            container: {
              color: themeUi.semantic.color.text.primary400
            }
          },

          storageTypeSection: {
            storageTypeItem: {
              color: themeUi.semantic.color.text.neutral800
            }
          }
        }
      },

      searchScalingFactor: {
        label: {
          color: themeUi.semantic.color.text.neutral700
        },

        components: {
          requestHigherFactor: {
            textButton: {
              borderTop: themeUi.semantic.color.text.secondary300
            }
          }
        }
      },

      supportedProtocol: {
        fieldName: {
          enabledColor: themeUi.semantic.color.text.neutral700,
          disabledColor: themeUi.semantic.color.text.neutral500
        },

        components: {
          supportedProtocolPopover: {
            popoverTitle: {
              color: themeUi.semantic.color.text.neutral800,
              fontSize: themeUi.core.font.fontSize.s16
            }
          },

          wrappers: {
            defaultRespWrapper: {
              fieldName: {
                color: themeUi.semantic.color.text.neutral800
              }
            }
          }
        }
      },

      transportLayerSecurity: {
        components: {
          certificateDetails: {
            certificateDetailsContainer: {
              borderTopColor: themeUi.semantic.color.border.secondary300
            },
            infoWithPipe: {
              borderRightColor: themeUi.semantic.color.border.secondary300
            },
            styledTable: {
              borderColor: themeUi.semantic.color.border.secondary300
            }
          },
          tlsClientAdd: {
            completeProcessInfoMessage: {
              borderTopColor: themeUi.semantic.color.border.secondary300,
              color: themeUi.semantic.color.text.neutral800
            },
            styledTable: {
              borderColor: themeUi.semantic.color.border.secondary300
            }
          },
          tlsClientView: {
            clientTLSIndicationContainer: {
              backgroundColor: themeUi.semantic.color.background.neutral500
            },
            styledTable: {
              borderColor: themeUi.semantic.color.border.secondary300
            }
          }
        }
      },

      viewModules: {
        label: {
          color: themeUi.semantic.color.text.neutral800
        },
        moduleItem: {
          color: themeUi.semantic.color.text.neutral700
        }
      }
    },

    databaseIconTooltip: {
      titleColor: themeUi.semantic.color.text.neutral800,
      textColor: themeUi.semantic.color.text.neutral700
    }
  }
};

export default subscriptionsAndDatabases;
